module.exports = __webpack_public_path__ + "img/SurpriseMe.8600588a.png";